import {
  Menu as FluentMenu,
  MenuProps as FluentMenuProps,
} from '@fluentui/react-components';
import React from 'react';
import { useFluentMountNode } from '../hooks';

export type MenuProps = FluentMenuProps;

/**
 * Themed Menu wrapper that automatically mounts its popover into
 * `#portal-root` (inside the app FluentProvider). Consumers can still
 * override `mountNode` if they need a different target.
 *
 * All Menu sub-components (`MenuTrigger`, `MenuPopover`, `MenuList`,
 * `MenuItem`, `MenuItemRadio`, `MenuItemCheckbox`, `MenuDivider`,
 * `MenuGroup`, `MenuGroupHeader`) are re-exported from
 * `@mnspro-cloud/components` for convenience.
 */
export const Menu: React.FC<MenuProps> = ({ mountNode, ...props }) => {
  const themedMountNode = useFluentMountNode();

  return <FluentMenu mountNode={mountNode ?? themedMountNode} {...props} />;
};

Menu.displayName = 'Menu';
